export default __webpack_public_path__ + "static/media/chartone.91e38a05.jpg";